<template>
  <div class="map-tabs">
    <div class="map-tabs__list container-fluid">
      <div v-for="(location, index) in locations"
           class="map-tabs__item"
           :class="{active: get_selected_location.location_city === location.location_city}"
           role="button"
           :aria-label="location.location_city"
           @click="changeLocation(location)"
           :key="`location${uid}-${index}`">
        {{ location.location_city }}
      </div>
    </div>
    <div
      class="position-relative map-tabs__map-block"
      v-if="get_selected_location">
      <office-map
        :frame_src="get_selected_location.frame_src"
        :key="`office-map-${selected_location_key_i}`"/>
      <div class="map-tabs__info">
        <div class="map-tabs__info__title">
          {{ get_selected_location.location_city }}
          <img src="/images/icons/triangle_down.svg" alt="arrow">
        </div>
        <div class="map-tabs__info__description">
          <div v-if="get_selected_location.location_address"
               class="map-tabs__info-row">
            <img src="/images/icons/location-on.svg" alt="map"/>
            {{ get_selected_location.location_address }}
          </div>
          <template v-if="Array.isArray(get_selected_location.location_emails)">
            <a v-for="item in get_selected_location.location_emails"
               :href="`mailto:${item.email}`"
               class="map-tabs__info-row link">
              <img src="/images/icons/mail.svg" alt="email"/>
              {{ item.email }}
            </a>
          </template>
          <template v-if="Array.isArray(get_selected_location.location_phones)">
            <a v-for="item in get_selected_location.location_phones"
               :href="`tel:${item.phone}`"
               class="map-tabs__info-row link">
              <img src="/images/icons/phone.svg" alt="phone"/>
              {{ item.phone }}
            </a>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OfficeMap from "../parts/OfficeMap.vue";
import SearchIcon from "../icons/SearchIcon.vue";

export default {
  name: "MapTabs",
  components: {
    SearchIcon,
    OfficeMap
  },
  props: {
    /**props**/
    locations: {
      type: Array,
      default: () => [],
      admin_type: 'array',
      array_values: {
        frame_src: {
          type: String,
          required: true,
          default: '',
          admin_type: 'textarea',
        },
        location_city: {
          type: String,
          default: '',
          admin_type: 'input',
        },
        location_address: {
          type: String,
          default: '',
          admin_type: 'textarea',
        },
        location_emails: {
          type: Array,
          default: () => [],
          admin_type: 'array',
          array_values: {
            email: {
              type: String,
              default: '',
              admin_type: 'input',
            },
          },
        },
        location_phones: {
          type: Array,
          default: () => [],
          admin_type: 'array',
          array_values: {
            phone: {
              type: String,
              default: '',
              admin_type: 'input',
            },
          },
        },
      },
    },
    /**props**/
  },
  computed: {
    uid() {
      return this._uid
    },
    get_selected_location() {
      return this.selected_location ? this.selected_location : this.locations.length ? this.locations[0] : null
    }
  },
  data() {
    return {
      selected_location: null,
      selected_location_key_i: 0,
    }
  },
  methods: {
    changeLocation(location) {
      this.selected_location = location
      this.selected_location_key_i++
    }
  }
}
</script>
